<template>
  <BaseSlider
    :value="value"
    :labels="question.answers"
    :states="states"
    @input="answer"
  />
</template>

<script>
import BaseSlider from './BaseSlider.vue'

const props = {
  question: {
    type: Object,
    required: true,
    validator: function(question) {
      if (!question.hasOwnProperty('text')) return false
      if (!question.hasOwnProperty('answers')) return false

      return true
    },
  },
}

const defaultStates = [
  {
    labels: [],
    color: '#ff6767',
  },
  {
    labels: [],
    color: '#ff7700',
  },
  {
    labels: [],
    color: '#33e44a',
  },
]

export default {
  props: props,
  states: [],
  components: { BaseSlider },

  created: function() {
    const mapLabelsInStates = (states, answer) => {
      if (answer.score < 0) states[0].labels.push(answer.text)
      else if (answer.score === 0) states[1].labels.push(answer.text)
      else states[2].labels.push(answer.text)
      return states
    }

    this.states = (this.question.answers || []).reduce(
      mapLabelsInStates,
      defaultStates
    )
  },

  computed: {
    value: function() {
      const answer = this.question.answered
      return !answer || answer === null ? null : answer.text
    },
  },

  methods: {
    answer: function(value) {
      this.$emit('answer', this.question.answers[value])
    },
  },
}
</script>
